class ResidenceAppointmentButton {
  title = "";
  createdby = "";
  updatedby = "";
}
export default ResidenceAppointmentButton;
